// Generated local fallback for retired upstream GraphQL endpoints.
/* eslint-disable */
export type AssetActivityPartsFragment = any
export type AssetQueryVariables = any
export type ContractInput = any
export type NftActivityFilterInput = any
export type NftApprovalPartsFragment = any
export type NftApproveForAllPartsFragment = any
export type NftAsset = any
export type NftAssetEdge = any
export type NftAssetsFilterInput = any
export type NftAssetTraitInput = any
export type NftCollection = any
export type NftRouteResponse = any
export type NftTrade = any
export type NftTradeInput = any
export type NftTransferPartsFragment = any
export type PermitInput = any
export type PortfolioBalancesQuery = any
export type SearchTokensQuery = any
export type TokenAmountInput = any
export type TokenApprovalPartsFragment = any
export type TokenPriceQuery = any
export type TokenQuery = any
export type TokenTradeInput = any
export type TokenTradeRouteInput = any
export type TokenTradeRoutesInput = any
export type TokenTransferPartsFragment = any
export type TopTokens100Query = any
export type TradePoolInput = any

export enum Chain { Arbitrum = 'ARBITRUM', Bnb = 'BNB', Celo = 'CELO', Ethereum = 'ETHEREUM', EthereumGoerli = 'ETHEREUM_GOERLI', EthereumSepolia = 'ETHEREUM_SEPOLIA', Harmony = 'HARMONY', Optimism = 'OPTIMISM', Polygon = 'POLYGON', UnknownChain = 'UNKNOWN_CHAIN' }
export enum Currency { Usd = 'USD' }
export enum HistoryDuration { Hour = 'HOUR', Day = 'DAY', Week = 'WEEK', Month = 'MONTH', Year = 'YEAR', Max = 'MAX' }
export enum TokenStandard { Native = 'NATIVE', Erc20 = 'ERC20' }
export enum TransactionStatus { Confirmed = 'CONFIRMED', Failed = 'FAILED', Pending = 'PENDING' }
export enum ActivityType { Approve = 'APPROVE', CancelListing = 'CANCEL_LISTING', Listing = 'LISTING', Mint = 'MINT', Receive = 'RECEIVE', Sale = 'SALE', Send = 'SEND', Swap = 'SWAP', Transfer = 'TRANSFER', Unknown = 'UNKNOWN' }
export enum NftAssetSortableField { Price = 'PRICE' }
export enum NftMarketplace { Opensea = 'OPENSEA' }
export enum NftActivityType { CancelListing = 'CANCEL_LISTING', Listing = 'LISTING', Sale = 'SALE', Transfer = 'TRANSFER' }
export enum NftStandard { Erc1155 = 'ERC1155', Erc721 = 'ERC721' }
export enum OrderStatus { Cancelled = 'CANCELLED', Executed = 'EXECUTED', Expired = 'EXPIRED', Valid = 'VALID' }
export enum OrderType { Listing = 'LISTING' }
export enum MediaType { Audio = 'AUDIO', Embed = 'EMBED', Image = 'IMAGE', Raw = 'RAW', Video = 'VIDEO' }
export enum SafetyLevel { MediumWarning = 'MEDIUM_WARNING', Verified = 'VERIFIED' }
export enum TokenTradeType { ExactOutput = 'EXACT_OUTPUT' }

export const useAssetQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useCollectionQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useCollectionSearchQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useDetailsQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useNftActivityQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useNftBalanceQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useNftUniversalRouterAddressQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const usePortfolioBalancesQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useRecentlySearchedAssetsQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useSearchTokensQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useTokenPriceQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useTokenQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useTokenSpotPriceQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useTopTokens100Query = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useTopTokensSparklineQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useTransactionListQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useTrendingCollectionsQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useTrendingTokensQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useUniswapPricesQuery = (..._args: any[]) => ({
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
})
export const useNftRouteLazyQuery = (..._args: any[]) => [async () => ({ data: undefined }), {
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
}] as const
export const usePortfolioBalancesLazyQuery = (..._args: any[]) => [async () => ({ data: undefined }), {
  data: undefined,
  loading: false,
  error: undefined,
  refetch: async () => ({ data: undefined }),
  fetchMore: async () => ({ data: undefined }),
}] as const
